import { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { Table, TableCell, TableRow, ThemeContext } from '@forma/forma-ui-kit';
import PageBlock from '@/components/PageBlock';
import formatPrice from '@/helpers/formatPrice';

import styles from './partnership-table.module.css';

const PartnershipTable = ({ title, items }) => {
  const { t } = useTranslation();
  const { currencies } = useContext(ThemeContext);
  const currency = currencies.ru;

  return (
    <PageBlock
      className={styles.root}
      title={title}
      variant="white"
    >
      <div className={styles.subtitle}>Вы получаете вознаграждение до 60%, а ваши клиенты — уникальный промокод на скидку 10% для первой оплаты любого тарифа.</div>
      <Table
        className={styles.table}
        columns={[
          { children: 'Тариф' },
          { children: 'Месяц' },
          { children: 'Стоимость' },
          { children: 'Условия' },
          { children: <span className={styles.rewardLabel}>Вознаграждение</span> },
        ]}
      >
        {items.map(({ tariff, patterns }) => (
          patterns.map(({ duration, price, debtPercent, debtFrom }) => (
            <TableRow key={`${tariff}.${duration}`}>
              <TableCell>{tariff}</TableCell>
              <TableCell>{duration}</TableCell>
              <TableCell>{formatPrice(price, currency)}</TableCell>
              <TableCell>{debtPercent}%</TableCell>
              <TableCell className={styles.rewardValue}>{t('from')} {formatPrice(debtFrom, currency)}</TableCell>
            </TableRow>
          ))
        ))}
      </Table>
    </PageBlock>
  );
};

export default PartnershipTable;
